import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

const Form = styled('form')`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${SPACINGS.base * 3}px;

  /**
   * TODO: PER-1771
   * Currently the spacing exists in <FormGroup/> for backwards compatibility
   * as margin-bottom.
   * We also have one-off styles for buttons since they don't get wrapped with
   * <FormGroup/>.
   * Once all forms are migrated, delete margin-bottom there and remove
   * grid-row-gap and button styles here.
   **/
  grid-row-gap: 0;
`;

export default Form;
